/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierContactInfo
 */
export interface CarrierContactInfo {
  /**
   *
   * @type {string}
   * @memberof CarrierContactInfo
   */
  customerServiceEmail: string;
  /**
   *
   * @type {string}
   * @memberof CarrierContactInfo
   */
  customerServicePhone: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof CarrierContactInfo
   */
  emailAddresses: { [key: string]: Array<string> };
}

/**
 * Check if a given object implements the CarrierContactInfo interface.
 */
export function instanceOfCarrierContactInfo(
  value: object,
): value is CarrierContactInfo {
  if (
    !("customerServiceEmail" in value) ||
    value["customerServiceEmail"] === undefined
  )
    return false;
  if (
    !("customerServicePhone" in value) ||
    value["customerServicePhone"] === undefined
  )
    return false;
  if (!("emailAddresses" in value) || value["emailAddresses"] === undefined)
    return false;
  return true;
}

export function CarrierContactInfoFromJSON(json: any): CarrierContactInfo {
  return CarrierContactInfoFromJSONTyped(json, false);
}

export function CarrierContactInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierContactInfo {
  if (json == null) {
    return json;
  }
  return {
    customerServiceEmail: json["customerServiceEmail"],
    customerServicePhone: json["customerServicePhone"],
    emailAddresses: json["emailAddresses"],
  };
}

export function CarrierContactInfoToJSON(json: any): CarrierContactInfo {
  return CarrierContactInfoToJSONTyped(json, false);
}

export function CarrierContactInfoToJSONTyped(
  value?: CarrierContactInfo | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    customerServiceEmail: value["customerServiceEmail"],
    customerServicePhone: value["customerServicePhone"],
    emailAddresses: value["emailAddresses"],
  };
}
